import { render } from "./form.vue?vue&type=template&id=09da000c&lang=pug"
import script from "./form.vue?vue&type=script&setup=true&lang=js"
export * from "./form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__